import { initConvex } from "convex-svelte/sveltekit";
import { CONVEX_URL } from "$lib/env";

// Initialize the client early so auth and queries can attach immediately.
initConvex(CONVEX_URL);
